import Enums from "../../enums/enums";
import shareHelper from "../../helper/shareHelper";
import * as api from "../../service/ApiSevice";
import store from "../baseController";
export const actions = {
  DoGetBannerItems({ commit }) {
    const user = store.getters.getUserModel;
    commit("MutationSetBannerItemsLoadingStatus", Enums.LoadingStatusType.Loading);
    let localStorageName = `bannerThumbnail-${user.userId.PeakEncryption()}`;
    let bannerThumbnail = localStorage.getItem(localStorageName);
    if (bannerThumbnail && shareHelper.CheckBannerThumbnailExpired(localStorageName)) {
      setTimeout(() => {
        commit("MutationSetBannerItems", JSON.parse(bannerThumbnail));
        commit("MutationSetBannerItemsLoadingStatus", Enums.LoadingStatusType.Success);
      }, 0);
    } else {
      api.BannerService.DoGetBannerItems().then((res) => {
        if (res.responseCode.IsSuccess() && res.bannerThumbnail) {
          localStorage.setItem(localStorageName, JSON.stringify([...res.bannerThumbnail.bannerThumbnailDetails]));
          shareHelper.SetBannerThumbnailTTL();
          commit("MutationSetBannerItems", res.bannerThumbnail.bannerThumbnailDetails);
          commit("MutationSetBannerItemsLoadingStatus", Enums.LoadingStatusType.Success);
        } else {
          commit("MutationSetBannerItemsLoadingStatus", Enums.LoadingStatusType.Failed);
        }
      });
    }
  },
  DoGetBannerDetail({ commit }, code) {
    commit("MutationSetBannerDetailLoadingStatus", Enums.LoadingStatusType.Loading);
    api.BannerService.DoGetBannerDetail(code).then((res) => {
      if (res.responseCode.IsSuccess()) {
        commit("MutationSetBannerDetail", res.bannerThumbnail);
        commit("MutationSetBannerDetailLoadingStatus", Enums.LoadingStatusType.Success);
      } else {
        commit("MutationSetBannerDetailLoadingStatus", Enums.LoadingStatusType.Failed);
      }
    });
  },
};
